// vim: set ts=2 sts=2 sw=2 et:

import React from "react";

interface FitToHeightProps {
  className: string;
  /** Alto natural del contenido, en px del lienzo. */
  naturalHeight: number;
  minScale: number;
  maxScale: number;
  children: React.ReactNode;
}

// Escala el contenido para llenar el alto que le deja el resto de la columna (el lugar lo reparte el flex del
// contenedor). Mide en cada render, sin ResizeObserver, porque los navegadores viejos de vMix no lo garantizan;
// la pantalla se vuelve a dibujar con cada tic del reloj.
const FitToHeight = ({ className, naturalHeight, minScale, maxScale, children }: FitToHeightProps) => {
  const slotRef = React.useRef<HTMLDivElement>(null);
  const [scale, setScale] = React.useState(maxScale);

  React.useLayoutEffect(() => {
    const available = slotRef.current?.clientHeight ?? 0;
    if (available <= 0) return;
    const next = Math.round(Math.min(maxScale, Math.max(minScale, available / naturalHeight)) * 1000) / 1000;
    if (next !== scale) setScale(next);
  });

  return (
    <div ref={slotRef} className={className}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: "bottom center" }}>{children}</div>
    </div>
  );
};

export default FitToHeight;
